import script from "./AgreementFields.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementFields.vue?vue&type=script&setup=true&lang=js"

import "./AgreementFields.vue?vue&type=style&index=0&id=328e0c14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-328e0c14"]])

export default __exports__